import type { FromModel } from "@/__main__/data-model.mjs";
import { Union } from "@/__main__/data-model.mjs";

export const cardBrandModel = Union([
  "amex",
  "diners",
  "discover",
  "jcb",
  "mastercard",
  "unionpay",
  "visa",
  "cb",
  "interac",
  "unknown",
]);

export type CardBrand = FromModel<typeof cardBrandModel>;
